"use client";

import { useState, useEffect } from "react";
import { useTranslations, useLocale } from "next-intl";

export default function MunaFullscreen() {
  const locale = useLocale();
  const t = useTranslations("Muna");
  const [isMounted, setIsMounted] = useState(false);
  
  useEffect(() => {
    setIsMounted(true);

    // Hapus semua script Jotform yang mungkin sudah dimuat sebelumnya
    const existingScripts = document.querySelectorAll('script[src*="jotfor.ms"]');
    existingScripts.forEach(script => script.remove());

    // Tambahkan script handler untuk iframe JotForm
    const handlerScript = document.createElement('script');
    handlerScript.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
    handlerScript.id = 'jotform-embed-handler';
    handlerScript.onload = function() {
      // Inisialisasi handler setelah script dimuat
      if (window.jotformEmbedHandler) {
        window.jotformEmbedHandler(
          "iframe[id='JotFormIFrame-01970aa2924175a1b0bdc07a27e22a278498']",
          "https://www.jotform.com"
        );
      }
    };
    document.body.appendChild(handlerScript);

    return () => {
      // Cleanup saat component unmount
      document.getElementById('jotform-embed-handler')?.remove();
    };
  }, []);
  
  if (!isMounted) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <p>{t("loading")}</p>
      </div>
    );
  }

  return (
    <div className="w-full h-screen">
      <iframe 
        id="JotFormIFrame-01970aa2924175a1b0bdc07a27e22a278498" 
        title="Muna: AI Agent"
        onLoad={() => {
          if (window.parent) {
            window.parent.scrollTo(0, 0);
          }
        }}
        allowTransparency={true}
        allow="geolocation; microphone; camera; fullscreen"
        src="https://agent.jotform.com/01970aa2924175a1b0bdc07a27e22a278498?embedMode=iframe&background=1&shadow=1"
        style={{
          minWidth: '100%',
          maxWidth: '100%',
          height: '100vh',
          border: 'none',
          width: '100%'
        }}
        scrolling="no"
        className="w-full h-full"
      />
    </div>
  );
}